import React from 'react'
import { AudioEngine } from '../engine/engine.js'

/** Global AudioEngine context */

export const AudioEngineContext = React.createContext<AudioEngine | null>(null)
export default AudioEngineContext
